import React, { Component } from 'react'
// import ChatBot from 'react-simple-chatbot'
import ReactSlider from 'react-slider'
import styled from 'styled-components'
import { flatten } from 'lodash'

// Utils
import { randomize } from '../data/utils'
import { es, fr, eng, ptg } from '../textApp/textTrad'

// Components
import Chatbot from './chatbot'
import LevelUp from './levelUp'
import Receive from './receiveData'
import Likert from './likert'

import {
  antrhopoEs,
  socialDisEs,
  brandLoveEs,
  brqEs,
  chatExpEs,
  colBluEs,
  antrhopoFr,
  socialDisFr,
  brandLoveFr,
  brqFr,
  chatExpFr,
  colBluFr,
  antrhopoEn,
  socialDisEn,
  brandLoveEn,
  brqEn,
  chatExpEn,
  colBluEn,
  antrhopoPtg,
  socialDisPtg,
  brandLovePtg,
  brqPtg,
  chatExpPtg,
  colBluPtg,
} from '../textApp/questions'

/// Global constants
const questionsData = {
  anthes: antrhopoEs,
  sociales: socialDisEs,
  brandLoes: brandLoveEs,
  brqes: brqEs,
  chates: chatExpEs,
  blues: colBluEs,
  anthfr: antrhopoFr,
  socialfr: socialDisFr,
  brandLofr: brandLoveFr,
  brqfr: brqFr,
  chatfr: chatExpFr,
  blufr: colBluFr,
  anthen: antrhopoEn,
  socialen: socialDisEn,
  brandLoen: brandLoveEn,
  brqen: brqEn,
  chaten: chatExpEn,
  bluen: colBluEn,
  anthpt: antrhopoPtg,
  socialpt: socialDisPtg,
  brandLopt: brandLovePtg,
  brqpt: brqPtg,
  chatpt: chatExpPtg,
  blupt: colBluPtg,
}

class ChatbotContainer extends Component {
  constructor(props) {
    super(props)

    this.listRef = React.createRef()
    this.state = {
      named: '',
      brand: '',
      editing: false,
      load: 2,
      updated: 0,
      updatedMount: 0,
      levelUp: false,
      sectionShow: 1,
      survAnsw: {
        rgpd: this.props.rgpd || '',
        brand: this.props.brand || '',
        language: this.props.lng || '',
        socDis: this.props.socDis || '',
        catego: this.props.catego || '',
        brandUsed: this.props.brandUsed || '',
        userId: this.props.userId || '',
      },
    }
    this.selectLang = this.selectLang.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.loadTopics = this.loadTopics.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.sendNavigate = this.sendNavigate.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // do things with nextProps.someProp and prevState.cachedSomeProp
    const { lng } = nextProps
    /// Select language
    ///
    const antrhopo = questionsData[`anth${lng}`]
    const socialDis = questionsData[`social${lng}`]
    const brandLove = questionsData[`brandLo${lng}`]
    const brq = questionsData[`brq${lng}`]
    const chatExp = questionsData[`chat${lng}`]

    const listTopicsBef = randomize([
      { qs: antrhopo, sctn: '0ant' },
      { qs: socialDis, sctn: '0socDi' },
      { qs: brandLove, sctn: '0brLv' },
      { qs: brq, sctn: '0brq' },
      { qs: chatExp, sctn: '0chatExp' },
    ])
    if (prevState.updatedMount === 0) {
      return {
        updatedMount: 1,
        topics: listTopicsBef,
      }
    }
    return null
  }
  componentDidMount() {
    const user = JSON.parse(localStorage.getItem('dataUser'))
    const { navigate, location } = this.props
    if ((user || '').endBot) {
      navigate('/end' + location.search)
    }
  }
  componentDidUpdate() {
    const user = JSON.parse(localStorage.getItem('dataUser'))
    if (
      user.name &&
      !this.props.catego &&
      !this.props.socDis &&
      !this.props.name
    ) {
      return {
        survAnsw: {
          userId: user.id,
          catego: user.catego,
          socDis: user.socDis,
          language: user.lng,
          rgpd: 'yes',
          name: user.name,
        },
      }
    }
  }
  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return es
      case 'fr':
        return fr
      case 'en':
        return eng
      case 'pt':
        return ptg
      default:
        return eng
    }
  }

  handleChange = (e, name) => {
    const steped = this.state[name + '_']
    const curState = this.state[name]
    // console.log('state', e, name)
    this.setState({
      survAnsw: { ...this.state.survAnsw, [name]: steped ? curState : e },
    })
    return true
  }
  handleNext = (e) => {
    this.setState({
      sectionShow: e,
    })
  }

  loadTopics = () => {
    const { lng } = this.props
    /// Select language
    ///
    const antrhopo = questionsData[`anth${lng}`]
    const socialDis = questionsData[`social${lng}`]
    const brandLove = questionsData[`brandLo${lng}`]
    const brq = questionsData[`brq${lng}`]
    const chatExp = questionsData[`chat${lng}`]

    const listTopicsBef = randomize([
      { qs: antrhopo, sctn: '0ant' },
      { qs: socialDis, sctn: '0socDi' },
      { qs: brandLove, sctn: '0brLv' },
      { qs: brq, sctn: '0brq' },
      { qs: chatExp, sctn: '0chatExp' },
    ])
    if (this.state.updated > 0) {
      return this.state.topics
    } else {
      this.setState({
        updated: this.state.updated + 1,
        topics: listTopicsBef,
      })
      return listTopicsBef
    }
  }
  sendNavigate = (e) => {
    const { navigate, location } = this.props
    navigate(e + location.search)
  }

  render() {
    const { topics, sectionShow, survAnsw } = this.state
    const topicsLoad = topics
    const brandSel = this.props.brand
    const { setlang, lng, user, setAns, location } = this.props

    const txt = this.selectLang()
    ///
    ///////////////////// Survey Questions /////////////////////
    const listTopics = topicsLoad ? topicsLoad.slice(0, 3) : []
    const list2Topics = topicsLoad ? topicsLoad.slice(3, topicsLoad.length) : []

    /// Select language Blue ////////////////////////
    const colBlu = questionsData[`blu${lng}`]
    const colorBlu = [{ qs: colBlu, sctn: '0colBlu' }]

    const totalQs = topicsLoad
      .concat(colorBlu)
      .reduce((total, val) => (total = total + val.qs.length), 0)

    const nbFirst = listTopics.reduce(
      (total, val) => (total = total + val.qs.length),
      0
    )
    const firstStep = Math.round((nbFirst / totalQs) * 100, 1)
    ///////////////////// End Blue //////////////////

    ///////////////////// STYLE /////////////////////
    const StyledSlider = styled(ReactSlider)`
      width: 100%;
      height: 25px;
    `
    const StyledThumb = styled.div`
      height: 25px;
      margin-left: 2%;
      line-height: 25px;
      width: 25px;
      font-weight: 800;
      text-align: center;
      background: linear-gradient(
        to right,
        rgb(255, 221, 0) 5%,
        rgba(251, 176, 52, 1)
      );
      color: #333232;
      border-radius: 50%;
      cursor: grab;
      visibility: hidden;
    `
    const StyledThumbAct = styled.div`
      height: 25px;
      margin-left: 2%;
      line-height: 25px;
      width: 25px;
      font-weight: 800;
      text-align: center;
      background: linear-gradient(
        to right,
        rgb(255, 221, 0) 5%,
        rgba(251, 176, 52, 1)
      );
      color: #333232;
      border-radius: 50%;
      cursor: grab;
      visibility: visible;
    `
    const Thumb = (props, state, active) => {
      return !active.active ? (
        <StyledThumb {...props}>{state.valueNow}</StyledThumb>
      ) : (
        <StyledThumbAct {...props}>{state.valueNow}</StyledThumbAct>
      )
    }

    const StyledTrack = styled.div`
      background: ${(props) =>
        props.index === 0
          ? 'linear-gradient(to right, rgba(251, 176, 52, 0.6) 5%, rgb(255, 221, 0))'
          : props.index === 1
          ? '#ddd'
          : '#ddd'};
      border-radius: 999px;
      height: 25px;
    `
    const Track = (props, state) => (
      <StyledTrack {...props} index={state.index} marks />
    )
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const globalList = listTopics
      ? listTopics.map((item, index) =>
          flatten(
            item['qs'].map((itm, indx) => {
              // const existAnswer = !!this.state.survAnsw[itm.idAns]
              return itm.message
                ? {
                    message: itm.message,
                    id: indx + itm.qGlobId,
                    delay: 300,
                    trigger:
                      index === listTopics.length - 1 && indx === item['qs']
                        ? 'end'
                        : indx === item['qs']
                        ? listTopics[index + 1]['sctn']
                        : indx + 1 + itm.qGlobId,
                  }
                : [
                    {
                      id: indx + itm.qGlobId,
                      message: itm.question,
                      trigger: indx + itm.globId,
                      metadata: { idSave: itm.idAns },
                      delay: 300,
                    },
                    {
                      id: indx + itm.globId,
                      asMessage: true,
                      delay: 450,
                      component: (
                        <Receive
                          trigger={
                            //Assess if question is the last of the topic
                            indx === item.qs.length - 1
                              ? //Asses if the topic is the last of the list of topics
                                index === listTopics.length - 1
                                ? // If yes send to the end of the survey
                                  'end'
                                : // Else send to the next topic
                                  listTopics[index + 1]['sctn']
                              : // If not las question, send to next question
                                indx + 1 + itm.qGlobId
                          }
                        >
                          {itm.img ? (
                            <div className={`img_surv ${itm.img}`} />
                          ) : (
                            ''
                          )}
                          <div
                            className='slider'
                            style={{
                              position: 'relative',
                            }}
                          >
                            <StyledSlider
                              onChange={(e) => this.handleChange(e, itm.idAns)}
                              className='horizontal-slider'
                              marks={[1, 2, 3, 4, 5, 6]}
                              markClassName='example-mark'
                              min={1}
                              max={6}
                              defaultValue={0}
                              thumbClassName={`example-thumb `}
                              trackClassName='example-track'
                              renderThumb={(e, i) =>
                                Thumb(e, i, {
                                  active: this.state.survAnsw[itm.idAns],
                                })
                              }
                              renderTrack={Track}
                            />
                          </div>
                          <Likert />
                        </Receive>
                      ),
                      metadata: { value: indx },
                      waitAction: true,
                    },
                  ]
            })
          )
        )
      : []
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const global2List = list2Topics
      ? list2Topics.map((item, index) =>
          flatten(
            item['qs'].map((itm, indx) => {
              return itm.message
                ? {
                    message: itm.message,
                    id: indx + itm.qGlobId,
                    delay: 300,
                    trigger:
                      index === list2Topics.length - 1 && indx === item['qs']
                        ? '0colBlu'
                        : indx === item['qs']
                        ? list2Topics[index + 1]['sctn']
                        : indx + 1 + itm.qGlobId,
                  }
                : [
                    {
                      id: indx + itm.qGlobId,
                      message: itm.question,
                      trigger: indx + itm.globId,
                      metadata: { idSave: itm.idAns },
                      delay: 300,
                    },
                    {
                      id: indx + itm.globId,
                      asMessage: true,
                      delay: 450,
                      component: (
                        <Receive
                          trigger={
                            //Assess if question is the last of the topic
                            indx === item.qs.length - 1
                              ? //Asses if the topic is the last of the list of topics
                                index === list2Topics.length - 1
                                ? // If yes send to the end of the survey
                                  '0colBlu'
                                : // Else send to the next topic
                                  list2Topics[index + 1]['sctn']
                              : // If not las question, send to next question
                                indx + 1 + itm.qGlobId
                          }
                        >
                          {itm.img ? (
                            <div className={`img_surv ${itm.img}`} />
                          ) : (
                            ''
                          )}
                          <div className='slider'>
                            <StyledSlider
                              onChange={(e) => this.handleChange(e, itm.idAns)}
                              className='horizontal-slider'
                              marks={[1, 2, 3, 4, 5, 6]}
                              markClassName='example-mark'
                              min={1}
                              max={6}
                              defaultValue={0}
                              thumbClassName='example-thumb'
                              trackClassName='example-track'
                              renderThumb={(e, i) =>
                                Thumb(e, i, {
                                  active: this.state.survAnsw[itm.idAns],
                                })
                              }
                              renderTrack={Track}
                              disabled={
                                this.state[itm.idAns + '_'] ? true : false
                              }
                            />
                          </div>
                          <Likert />
                        </Receive>
                      ),
                      metadata: { value: indx },
                      waitAction: true,
                    },
                  ]
            })
          )
        )
      : []
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const colBlueList = colorBlu
      ? colorBlu.map((item, index) =>
          flatten(
            item['qs'].map((itm, indx) => {
              return itm.message
                ? {
                    message: itm.message,
                    id: indx + itm.qGlobId,
                    delay: 200,
                    trigger:
                      index === colorBlu.length - 1 && indx === item['qs']
                        ? 'end'
                        : indx === item['qs']
                        ? colorBlu[index + 1]['sctn']
                        : indx + 1 + itm.qGlobId,
                  }
                : [
                    {
                      id: indx + itm.qGlobId,
                      message: itm.question,
                      trigger: indx + itm.globId,
                      metadata: { idSave: itm.idAns },
                      delay: 200,
                    },
                    {
                      id: indx + itm.globId,
                      asMessage: true,
                      delay: 500,
                      component: (
                        <Receive
                          trigger={
                            //Assess if question is the last of the topic
                            indx === item.qs.length - 1
                              ? //Asses if the topic is the last of the list of topics
                                index === colorBlu.length - 1
                                ? // If yes send to the end of the survey
                                  'end'
                                : // Else send to the next topic
                                  colorBlu[index + 1]['sctn']
                              : // If not las question, send to next question
                                indx + 1 + itm.qGlobId
                          }
                        >
                          <div className='slider'>
                            <StyledSlider
                              onChange={(e) => this.handleChange(e, itm.idAns)}
                              className='horizontal-slider'
                              marks={[1, 2, 3, 4, 5, 6]}
                              markClassName='example-mark'
                              min={1}
                              max={6}
                              defaultValue={0}
                              thumbClassName='example-thumb'
                              trackClassName='example-track'
                              renderThumb={(e, i) =>
                                Thumb(e, i, {
                                  active: this.state.survAnsw[itm.idAns],
                                })
                              }
                              renderTrack={Track}
                              disabled={
                                this.state[itm.idAns + '_'] ? true : false
                              }
                            />
                          </div>
                          <Likert />
                        </Receive>
                      ),
                      metadata: { value: indx },
                      waitAction: true,
                    },
                  ]
            })
          )
        )
      : []
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //////////////////// JOINING SECOND LISTO TO BLUE QUESTIONS ////////////////////
    const secondList = global2List.concat(colBlueList)
    //////////////////// END JOINING SECOND LISTO TO BLUE QUESTIONS ////////////////

    return globalList && sectionShow === 1 ? (
      <Chatbot
        list={globalList}
        txt={txt}
        brand={brandSel}
        stage={'start'}
        handleNext={this.handleNext}
        sectionShow={sectionShow}
        lng={lng}
        user={user}
        survAnsw={survAnsw}
        navigate={this.props.navigate}
        setAns={setAns}
        location={location}
        analytics={{
          name: 'Phase 1',
          path: 'chatbot1',
          location: 'chatbot1',
        }}
      />
    ) : sectionShow === 2 ? (
      <LevelUp
        setlang={setlang}
        lng={lng}
        handleNext={this.handleNext}
        sectionShow={sectionShow}
        user={user}
        purcent={firstStep}
        location={location}
      />
    ) : (
      <Chatbot
        list={secondList}
        txt={txt}
        brand={brandSel}
        stage={'start'}
        handleNext={this.handleNext}
        sectionShow={sectionShow}
        lng={lng}
        user={user}
        survAnsw={survAnsw}
        navigate={this.props.navigate}
        setAns={setAns}
        location={location}
        analytics={{
          name: 'Phase 2',
          path: 'chatbot2',
          'location ': 'chatbot2',
        }}
      />
    )
  }
}
export default ChatbotContainer
